// extracted by mini-css-extract-plugin
export default {"storeIn":"AboutStoreIntegration_storeIn__GjYNf","header":"AboutStoreIntegration_header__UQ-Dq","texts":"AboutStoreIntegration_texts__Z30zK"};